import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import Text, { Inline } from './base/Text';
import { Flex } from './base/layout-components';

const FlexEndText = styled(Text)`
  display: flex;
  align-items: flex-end;
`;

const ScoreWithDelta = ({
  score = '-',
  outOf = null,
  subTitle = '',
  delta = null,
  name,
  dataCyPrefix = ''
}) => {
  const color = delta < 0 ? 'torchRed' : 'malachite';
  const dataCy = `${dataCyPrefix}-${name.replace(/\s+/g, '-')}-value`;

  return (
    <Flex direction='column'>
      <Flex direction='row'>
        <Inline
          size='huge'
          weight='400'
          lineHeight='3.3rem'
          data-custom-attr={`${(name || '')
            .trim()
            .replace(/ /g, '')
            .toLowerCase()}`}
          data-cy={dataCy}
        >
          {score < -1000 || score > 1000
            ? numeral(score).format('0.0a')
            : score}
        </Inline>

        <Flex direction='column' justify='space-between'>
          {delta ? (
            <Text size='large' color={color}>{`(${
              delta < -1000 || delta > 1000
                ? `${delta > 0 ? '+' : ''}${numeral(delta).format('0.0a')}`
                : `${delta > 0 ? '+' : ''}${delta}`
            })`}</Text>
          ) : (
            <Text />
          )}
          {outOf ? (
            <FlexEndText pb='1rem' size='medium' weight='400'>
              /100
            </FlexEndText>
          ) : null}
        </Flex>
      </Flex>

      <Text size='small' weight='normal'>
        {subTitle}
      </Text>
    </Flex>
  );
};

ScoreWithDelta.propTypes = {
  score: PropTypes.any,
  outOf: PropTypes.string,
  subTitle: PropTypes.string,
  delta: PropTypes.any
};

export default ScoreWithDelta;
